module.exports = __webpack_public_path__ + "img/b7.d30c8b57.png";